import styled from "styled-components";

import designSystemColors from "../../../../styles";

export const FieldLabel = styled.label`
  display: block;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  margin-bottom: 6px;
`;

export const ReadOnlyField = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  color: #374151;
  font-family: Inter, sans-serif;
  font-size: 14px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;

const footerButtonBase = `
  height: 40px;
  padding: 0 1rem;
  border-radius: 4px;
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 700;
  transition: 0.2s;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const FooterCancelButton = styled.button`
  ${footerButtonBase}
  border: 1px solid ${designSystemColors.cancelButtons};
  background-color: ${designSystemColors.background};
  color: ${designSystemColors.cancelButtons};

  &:hover:not(:disabled) {
    opacity: 0.5;
  }
`;

export const FooterConfirmButton = styled.button`
  ${footerButtonBase}
  border: none;
  background-color: ${designSystemColors.secondaryButtons};
  color: ${designSystemColors.textGeneralButtons};

  &:hover:not(:disabled) {
    opacity: 0.8;
  }
`;

export const FormField = styled.div`
  margin-bottom: 16px;
`;

export const ChangeProductButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 6px 12px;
  border: 1px solid ${designSystemColors.generalButtons};
  border-radius: 6px;
  background: #fff7f5;
  color: ${designSystemColors.generalButtons};
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #ffece6;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ProductRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 12px;
  }

  & > span {
    display: inline-flex;
    align-items: center;
  }
`;